window.theme = window.theme || {};
theme.tab_content = function () {
  var tab_heading = document.querySelectorAll('.tab-head');
  tab_heading.forEach(button => button.addEventListener('click', function () {
    var index = this.getAttribute('data-index');
    var closest = this.closest('.tab-content-main-wrapper');
    closest.querySelectorAll('.tab-head').forEach(function (item) {
      item.classList.remove('active');
    });
    closest.querySelectorAll('.tab-content').forEach(function (item) {
      item.style.display = 'none';
    });
    closest.querySelector(`.tab-head[data-index='${index}']`).classList.add('active');
    closest.querySelector(`.tab-content[data-index='${index}']`).style.display = 'block';
    var closest_classlist = $(this).closest('.tab-content-main-wrapper');
    console.log("closessst", $(closest_classlist).find('.tab-content:visible .plans-slider'));
    if ($(closest_classlist).find(`.tab-content:visible .plans-slider.slick-initialized`).length > 0) {
      $(closest_classlist).find('.tab-content:visible .plans-slider').slick('unslick');
      $(closest_classlist).find('.tab-content:visible .plans-slider').resize();
    }
    theme.match_media_plan(closest_classlist);
  }));
};
theme.custom_banner_slider = function () {
  $('.custom_banner_slider').slick({
    infinite: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
  });
};
// theme.custom_megamenu_click = function(){
//   $(".custom_mega_menu .header__menu-item").on("click", function(){
//       $(this).closest(".custom_mega_menu").toggleClass("active");
//   });
// };
theme.plans_tab_slider = function (closest) {
  $(closest).find('.tab-content:visible .plans-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}
theme.match_media_plan = function (closest) {
  if (window.matchMedia("(max-width: 749px)").matches) {
    if ($(closest).find('.tab-content:visible .plans-slider').data('collection-size') > 1) {
      // console.log("749");
      theme.plans_tab_slider(closest);
    }
  } else if (window.matchMedia("(max-width: 989px)").matches && window.matchMedia("(min-width: 748px)").matches) {
    if ($(closest).find('.tab-content:visible .plans-slider').data('collection-size') > 2) {
      // console.log("989 748");
      theme.plans_tab_slider(closest);
    }
  } else {
    if ($(closest).find('.tab-content:visible .plans-slider').data('collection-size') > 3) {
      // console.log("dektop");
      theme.plans_tab_slider(closest);
    }
  }
}

theme.getUrlFilterMap = function () {
  const currentUrl = window.location.href;
  getUrlParameter(currentUrl);

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  // Check if the "availability" parameter is true
  var availability = getUrlParameter('availability');
  if (availability === 'true') {
    // Add a class to the body
    document.body.classList.add('filter_avilable_top');
  }
}

theme.coveragePageLoader = function () {
  window.addEventListener('load', function () {
    document.getElementById('coverage_loader') ? document.getElementById('coverage_loader').style.display = 'none' : '';
    document.getElementById('ucmMap') ? document.getElementById('ucmMap').style.display = 'flex' : '';
  });

  // Hide loader when page finishes loading
  window.addEventListener('DOMContentLoaded', function () {
    document.getElementById('coverage_loader') ? document.getElementById('coverage_loader').style.display = 'block' : '';
    document.getElementById('ucmMap') ? document.getElementById('ucmMap').style.display = 'none' : '';
  });
}
theme.coverage_orderNow_click = function () {
  // Bind the delegated listener only once, even if this is called again.
  if (theme._coverageOrderNowBound) return;
  theme._coverageOrderNowBound = true;

  // Event delegation on document instead of binding the element directly.
  // The "Order Now" button is a live <a href> that the coverage section
  // re-injects on every address search (via setTimeout). A directly-bound
  // listener created a race: a fast click before the listener attached — or on
  // a freshly re-injected button after the poller had stopped — followed the
  // raw href and skipped checkCoverage(). A delegated listener is active from
  // page load and survives every re-injection, so preventDefault + the
  // coverage check always run before any redirect.
  document.addEventListener('click', async function (e) {
    const button = e.target.closest('.has_product_available');
    if (!button) return;

    e.preventDefault();

    // Guard against repeat clicks while a check is already in flight.
    if (button.dataset.coverageChecking === '1') return;

    const address = document.querySelector('#infoWindow span')?.innerText;
    const redirectUrl = button.getAttribute('href');
    const originalText = button.innerText;

    button.dataset.coverageChecking = '1';
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.6';
    button.innerText = 'Checking...';

    function restoreButton() {
      button.dataset.coverageChecking = '';
      button.style.pointerEvents = '';
      button.style.opacity = '';
      button.innerText = originalText;
    }

    const amids = theme.result_payload_data.results.items[0].payload.AMID;
    let payload = { address: address, amid: amids };

    const buildingInfos = document.querySelector('.infoWindowContent');
    if (buildingInfos) {
      payload.buildName = theme.result_payload_data.results.items[0].payload.buildingNumberInfo?.buildingInfo[0].BUILDING_NAME;
      payload.buildFloor = theme.result_payload_data.results.items[0].payload.buildingNumberInfo?.buildingInfo[0].FLOOR;
      payload.unit = theme.result_payload_data.results.items[0].payload.buildingNumberInfo?.buildingInfo[0].NUM;
    }

    console.log('[Coverage] Payload:', payload);
    const eligibility = await checkCoverage(payload);

    if (eligibility.blocked) {
      restoreButton();
      return;
    }

    // Build and persist location data — only on proceed or confirmed conversion
    const p = theme.result_payload_data.results.items[0].payload;
    console.log('[Coverage] GIS Payload AddressInfo:', p.AddressInfo);
    console.log('[Coverage] GIS Payload Full:', p);
    theme.locationData = {
      shop: Shopify.shop,
      country: p.AddressInfo.LR_COUNTRY,
      city: p.AddressInfo.LR_TOWN,
      amid: p.AMID,
      suburb: p.AddressInfo.LR_SUBURB,
      street1: p.AddressInfo.LR_STREET,
      // Per client: treat LR_PROVINCE (e.g. "WESTERN CAPE") as the Region value,
      // not the GIS REGION field.
      region: p.AddressInfo.LR_PROVINCE,
      province: p.AddressInfo.LR_PROVINCE,
      postalCode: p.AddressInfo.LR_PO_CODE_STREET,
      longitude: p.LON,
      latitude: p.LAT,
      buildingName: p.buildingNumberInfo?.buildingInfo[0].BUILDING_NAME,
      floor: p.buildingNumberInfo?.buildingInfo[0].FLOOR,
      unit: p.buildingNumberInfo?.buildingInfo[0].NUM,
      address: p.AddressInfo.ADDRESS || p.AddressInfo.LR_Address,
      address1: p.AddressInfo.LR_Address || p.AddressInfo.ADDRESS,
      conversionFlag: eligibility.conversion ? true : false,
      circuitNumber: eligibility.conversion ? eligibility.circuitNumber : null
    };

    console.log('[Coverage] locationData:', theme.locationData);
    localStorage.setItem('locationData', JSON.stringify(theme.locationData));

    const convSeparator = redirectUrl.includes('?') ? '&' : '?';
    window.location.href = eligibility.conversion
      ? redirectUrl + convSeparator + 'scenario=conversion'
      : redirectUrl;
  });
};

async function checkCoverage(payload) {
  let res;
  try {
    res = await fetch('https://shopifyapp.openserve.co.za/api/getAddress', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  } catch (err) {
    console.error('[Coverage] Network error:', err);
    showEligibilityModal('Unable to reach the server. Please check your connection and try again.');
    return { blocked: true };
  }

  if (!res.ok) {
    console.error('[Coverage] HTTP error:', res.status);
    showEligibilityModal('Something went wrong. Please try again.');
    return { blocked: true };
  }

  const response = await res.json();

  if (!response.success) {
    console.error('[Coverage] API error:', response.error);
    showEligibilityModal(response.error || 'Something went wrong. Please try again.');
    return { blocked: true };
  }

  const data = response.data;
  const hasOpenFibreOrder = data.hasOpenFibreOrder;
  const productTypes = data.productTypes || [];
  const circuitNumbers = data.circuitNumbers || [];

  console.log('[Coverage] hasOpenFibreOrder:', hasOpenFibreOrder, '| productTypes:', productTypes, '| circuitNumbers:', circuitNumbers);

  // Priority 1 — Open order in progress (highest priority)
  if (hasOpenFibreOrder === true) {
    showEligibilityModal('An open order is in progress. Please contact your ISP.');
    return { blocked: true };
  }

  // Priority 2 — OpenAccessPrepaid: offer conversion to subscription
  if (productTypes.includes('OpenAccessPrepaid')) {
    const circuitNumber = circuitNumbers[0] || null;
    if (!circuitNumber) {
      console.warn('[Coverage] OpenAccessPrepaid found but CircuitNumber is missing — blocking journey.');
      showEligibilityModal('A service was found at this address but could not be verified. Please contact your ISP.');
      return { blocked: true };
    }
    const confirmed = await showConversionModal(
      'We have an Open Access Prepaid service at the address, Would you like to convert it to a subscription service'
    );
    if (confirmed) {
      return { blocked: false, conversion: true, circuitNumber };
    }
    return { blocked: true };
  }

  // Priority 3 — Existing service blocks journey
  if (productTypes.includes('ClosedPrepaid') || productTypes.includes('ISPUncappedBundlePostpaid')) {
    showEligibilityModal('A service already exists at this address. Please contact your ISP.');
    return { blocked: true };
  }

  // Priority 4 — No blocking condition: proceed to browse deal page
  return { blocked: false, conversion: false };
}

function showEligibilityModal(message, redirectOnClose) {
  ensureEligibilityModal();
  const modal = document.getElementById('eligibility-modal');
  modal.querySelector('.eligibility-modal__message').textContent = message;
  modal.querySelector('.eligibility-modal__actions--block').style.display = 'flex';
  modal.querySelector('.eligibility-modal__actions--conversion').style.display = 'none';
  modal.classList.add('eligibility-modal--open');
  if (redirectOnClose) {
    var closeBtn = modal.querySelector('.eligibility-modal__close');
    function onCloseRedirect() {
      closeBtn.removeEventListener('click', onCloseRedirect);
      window.location.href = redirectOnClose;
    }
    closeBtn.addEventListener('click', onCloseRedirect);
  }
}

function showConversionModal(message) {
  return new Promise(function (resolve) {
    ensureEligibilityModal();
    const modal = document.getElementById('eligibility-modal');
    modal.querySelector('.eligibility-modal__message').textContent = message;
    modal.querySelector('.eligibility-modal__actions--block').style.display = 'none';
    modal.querySelector('.eligibility-modal__actions--conversion').style.display = 'flex';
    modal.classList.add('eligibility-modal--open');

    const yesBtn = modal.querySelector('.eligibility-modal__yes');
    const noBtn = modal.querySelector('.eligibility-modal__no');

    function cleanup() {
      yesBtn.removeEventListener('click', onYes);
      noBtn.removeEventListener('click', onNo);
    }
    function onYes() {
      cleanup();
      modal.classList.remove('eligibility-modal--open');
      resolve(true);
    }
    function onNo() {
      cleanup();
      modal.classList.remove('eligibility-modal--open');
      resolve(false);
    }

    yesBtn.addEventListener('click', onYes);
    noBtn.addEventListener('click', onNo);
  });
}

function ensureEligibilityModal() {
  if (document.getElementById('eligibility-modal')) return;

  const style = document.createElement('style');
  style.textContent = `
    #eligibility-modal { display:none; position:fixed; inset:0; z-index:10000; align-items:center; justify-content:center; }
    #eligibility-modal.eligibility-modal--open { display:flex; }
    .eligibility-modal__overlay { position:absolute; inset:0; background:rgba(0,0,0,0.5); }
    .eligibility-modal__dialog { position:relative; background:#fff; border-radius:8px; padding:3.2rem 2.4rem 2.4rem; max-width:480px; width:90%; text-align:center; box-shadow:0 8px 32px rgba(0,0,0,0.18); }
    .eligibility-modal__message { font-size:1.6rem; line-height:1.5; margin:0 0 2.4rem; color:#333; }
    .eligibility-modal__actions { display:flex; gap:1.2rem; justify-content:center; }
    .eligibility-modal__actions button { min-width:120px; }
  `;
  document.head.appendChild(style);

  document.body.insertAdjacentHTML('beforeend', `
    <div id="eligibility-modal" class="eligibility-modal" role="dialog" aria-modal="true">
      <div class="eligibility-modal__overlay"></div>
      <div class="eligibility-modal__dialog">
        <p class="eligibility-modal__message"></p>
        <div class="eligibility-modal__actions eligibility-modal__actions--block" style="display:none">
          <button class="eligibility-modal__close button">Close</button>
        </div>
        <div class="eligibility-modal__actions eligibility-modal__actions--conversion" style="display:none">
          <button class="eligibility-modal__no button button--secondary">No</button>
          <button class="eligibility-modal__yes button">Yes</button>
        </div>
      </div>
    </div>
  `);

  document.querySelector('#eligibility-modal .eligibility-modal__close').addEventListener('click', function () {
    document.getElementById('eligibility-modal').classList.remove('eligibility-modal--open');
  });
}
theme.data_post = function () {
  let location_data = JSON.parse(localStorage.getItem('locationData'));
  console.log('location_data', location_data);
  const formdata = new FormData();
  formdata.append("shop", location_data.shop);
  formdata.append("country", location_data.country);
  formdata.append("city", location_data.city);
  formdata.append("buildingName", location_data.buildingName);
  formdata.append("floor", location_data.floor);
  formdata.append("unit", location_data.unit);
  formdata.append("amid", location_data.amid);
  formdata.append("suburb", location_data.suburb);
  formdata.append("street1", location_data.street1);
  formdata.append("region", location_data.region);
  formdata.append("longitude", location_data.longitude);
  formdata.append("latitude", location_data.latitude);
  console.log('formdata', formdata);
  const settings = {
    "url": "https://shopifyapp.openserve.co.za/api/storeAddress",
    "method": "POST",
    "timeout": 0,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    "dataType": "json",
    "data": formdata
  };

  // $.ajax(settings).done(function (response) {
  //   console.log('response',response);
  // });
}

theme.ticket_data_list_api = function () {
  console.log("ticket data api called");
  // if customer is login ticket list
  const formdata = new FormData();
  let shop_name = 'hetarth-brahmbhatt.myshopify.com';
  let customer_id = '12345';
  console.log('formdata', formdata);
  const settings = {
    "url": `https://shopifyapp.openserve.co.za/api/ticketList/?customerId=${customer_id}&shop=${shop_name}`,
    "method": "GET",
    "timeout": 0,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    "dataType": "json",
    "data": formdata
  };

  $.ajax(settings).done(function (response) {
    console.log('response', response);
    let response_dataList = response.data, parentNode = document.getElementById('customer_ticket_list');
    let tbody_html = '', table_html = '';
    console.log('response_dataList', response_dataList);
    if (response_dataList != null || response_dataList != '') {
      console.log("not null");
      response_dataList.forEach(function (item, index) {
        console.log('item', item.id);
        tbody_html += `<tr> <td>${item.ticket_id}</td> <td>${item.type}</td> <td>${item.status}</td> <td>${item.created_at}</td> </tr>`
      });
      table_html = `<table width="100%" border="1"> <thead> <tr> <th>Ticket Id</th> <th>Type</th> <th>status</th> <th>Created At</th> </tr> </thead> <tbody> ${tbody_html} </tbody> </table>`
      parentNode.innerHTML = table_html;
    } else {
      console.log("null");
    }
  });
}
theme.ticket_form_submit_api = function () {
  var form = document.getElementById('ticket-form');
  // Add submit event listener to the form
  form?.addEventListener('submit', function (event) {
    event.preventDefault();
    // Get form data
    console.log("form submit called");
    var get_formData = new FormData(form);
    const formdata = new FormData();
    formdata.append("first_name", get_formData.get('first_name'));
    formdata.append("last_name", get_formData.get('last_name'));
    formdata.append("contact_no", get_formData.get('contact_no'));
    formdata.append("ticket_type", get_formData.get('ticket_type'));
    formdata.append("priority", get_formData.get('priority'));
    formdata.append("urgency", get_formData.get('urgency'));
    formdata.append("severity", get_formData.get('severity'));
    formdata.append("category", get_formData.get('category'));
    formdata.append("cause", get_formData.get('cause'));
    formdata.append("subject", get_formData.get('subject'));
    formdata.append("escalation_indicator", get_formData.get('escalation_indicator'));
    formdata.append("direct_routing", get_formData.get('direct_routing'));
    formdata.append("shop", Shopify.shop);
    formdata.append("ticket_status", 'Submitted');
    console.log('formdata', formdata);
    const settings = {
      "url": "https://shopifyapp.openserve.co.za/api/createTicket",
      "method": "POST",
      "timeout": 0,
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "dataType": "json",
      "data": formdata
    };

    $.ajax(settings).done(function (response) {
      console.log('response', response);
      // form.submit();
    });
  });
}
function revealRicaForm() {
  const splash = document.getElementById('rds-splash');
  const content = document.getElementById('rds-form-content');
  if (splash) { splash.classList.add('rds-splash-out'); setTimeout(() => { splash.style.display = 'none'; }, 500); }
  if (content) { content.style.display = 'block'; }
}

theme.rica_document_submit = function () {
  var form = document.getElementById('rica-document-submit');
  var splash = document.getElementById('rds-splash');
  var MIN_SPLASH_MS = 3000;
  var SA_PHONE_RE = /^(\+27|27|0)[6-8][0-9]{8}$/;
  var otp = { target: null, phoneToken: null, altToken: null, timer: null };

  // OTP stores have no Shopify customer id, so the RICA record must be fetched
  // by the customer's own JWT (phone-scoped) via /api/customer/document — never
  // by customer_id, which they don't have and which could return another
  // customer's record. Returns the full record (name, ID, dummy email) plus
  // pre-auth tokens so the login phone (already OTP-verified) isn't re-verified.
  if (window.osCustomer && window.osCustomer.loggedIn) {
    fetch('https://shopifyapp.openserve.co.za/api/customer/document', {
      headers: { 'Authorization': 'Bearer ' + OsSession.get() }
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || !res.success || !res.data) return;
      var d = res.data;
      var setIfEmpty = function (id, val) {
        var el = document.getElementById(id);
        if (el && !el.value && val != null && val !== '') el.value = val;
      };
      setIfEmpty('email', d.email);
      setIfEmpty('first_name', d.first_name);
      setIfEmpty('last_name', d.last_name);
      setIfEmpty('phone', d.phone);
      setIfEmpty('alt_phone', d.alt_phone);
      setIfEmpty('id_type', d.id_type);
      setIfEmpty('id_number', d.id_number);
      var phoneWa = document.getElementById('phone_whatsapp');
      var altWa = document.getElementById('alt_phone_whatsapp');
      if (phoneWa && d.phone_whatsapp === 1) phoneWa.checked = true;
      if (altWa && d.alt_phone_whatsapp === 1) altWa.checked = true;
      var idTypeEl = document.getElementById('id_type');
      if (idTypeEl && idTypeEl.value) idTypeEl.dispatchEvent(new Event('change'));
      // Auto-verify numbers already on record so the customer skips OTP unless
      // they change one (the primary phone is their just-verified login number).
      if (d.phone_preauth_token && d.phone) setVerified('phone', d.phone_preauth_token);
      if (d.alt_phone_preauth_token && d.alt_phone) setVerified('alt_phone', d.alt_phone_preauth_token);
    }).catch(function () {});
  }

  // Animate steps sequentially: step 0 at 0ms, step 1 at 1000ms, step 2 at 2000ms
  [0, 1, 2].forEach(function (i) {
    setTimeout(function () {
      var prev = document.getElementById('rds-step-' + (i - 1));
      if (prev) { prev.classList.remove('rds-step-active'); prev.classList.add('rds-step-done'); }
      var el = document.getElementById('rds-step-' + i);
      if (el) el.classList.add('rds-step-active');
    }, i * 1000);
  });

  function finishSteps() {
    [0, 1, 2].forEach(function (i) {
      var el = document.getElementById('rds-step-' + i);
      if (el) { el.classList.remove('rds-step-active'); el.classList.add('rds-step-done'); }
    });
  }
  function splashSuccess(callback) {
    finishSteps();
    if (splash) splash.classList.add('rds-splash-success');
    setTimeout(callback, 800);
  }

  // ── OTP helpers ─────────────────────────────────────────────────────
  function otpDigitsValue() {
    return Array.from(document.querySelectorAll('.otp-digit')).map(function (el) { return el.value; }).join('');
  }
  function clearOtpDigits() {
    document.querySelectorAll('.otp-digit').forEach(function (el) { el.value = ''; el.classList.remove('otp-error'); });
    var errEl = document.getElementById('otp-error-msg');
    if (errEl) errEl.innerText = '';
  }
  function startCountdown(seconds) {
    clearTimeout(otp.timer);
    var cdEl = document.getElementById('otp-countdown-text');
    var remaining = seconds;
    function tick() {
      if (!cdEl) return;
      if (remaining <= 0) {
        cdEl.innerHTML = 'Didn\'t receive it? <span id="otp-resend-link" style="color:#006680;text-decoration:underline;cursor:pointer;font-weight:600;">Resend OTP</span>';
        var resendEl = document.getElementById('otp-resend-link');
        if (resendEl) resendEl.addEventListener('click', function () {
          var inputId = otp.target === 'phone' ? 'phone' : 'alt_phone';
          openOtpModal(otp.target, (document.getElementById(inputId)?.value || '').trim());
        });
        return;
      }
      cdEl.innerText = 'Resend available in ' + remaining + 's';
      remaining--;
      otp.timer = setTimeout(tick, 1000);
    }
    tick();
  }
  function checkSubmitReady() {
    var consentEl = document.getElementById('consent');
    var submitBtn = document.querySelector('.rds-submit-btn');
    var altEl = document.getElementById('alt_phone');
    var altVal = (altEl && altEl.value || '').trim();
    var altNeeded = altVal !== '' && SA_PHONE_RE.test(altVal);
    var ready = consentEl && consentEl.checked && otp.phoneToken && (!altNeeded || otp.altToken);
    if (submitBtn) submitBtn.disabled = !ready;
  }
  function showFormBanner(text, type) {
    var el = document.querySelector('.form-success-response.rds-success');
    if (!el) return;
    el.innerText = text;
    if (type === 'error') {
      el.style.background = '#fff5f5'; el.style.color = '#c53030'; el.style.borderColor = '#fc8181';
    } else {
      el.style.background = '#f0fff4'; el.style.color = '#276749'; el.style.borderColor = '#9ae6b4';
    }
    el.style.display = 'block';
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  // Lock / unlock the form behind the modal so user can't edit while verifying
  function lockForm() {
    var formEl = document.getElementById('rica-document-submit');
    if (formEl) formEl.inert = true;
  }
  function unlockForm() {
    var formEl = document.getElementById('rica-document-submit');
    if (formEl) formEl.inert = false;
  }

  // Switch which view is visible inside the modal (sending | input | error)
  function showOtpView(view) {
    ['otp-sending-view', 'otp-input-view', 'otp-send-error-view'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = (id === view) ? 'block' : 'none';
    });
  }

  // Normalise a SA phone number for display: always +27XXXXXXXXX
  function displayPhone(raw) {
    var clean = raw.replace(/\s/g, '');
    if (clean.startsWith('+27')) return clean;
    if (clean.startsWith('27')) return '+' + clean;
    if (clean.startsWith('0')) return '+27' + clean.slice(1);
    return clean;
  }

  function openOtpModal(target, phoneValue) {
    otp.target = target;
    var sendingView = document.getElementById('otp-sending-view');

    // Reset step states from any previous attempt
    [0, 1, 2].forEach(function (i) {
      var el = document.getElementById('otp-step-' + i);
      if (el) el.classList.remove('active', 'done');
    });
    if (sendingView) sendingView.classList.remove('otp-send-success');

    // 1. Open modal immediately in "sending" state
    var sendingText = document.getElementById('otp-sending-text');
    if (sendingText) sendingText.innerText = 'Sending code to ' + displayPhone(phoneValue) + '\u2026';
    showOtpView('otp-sending-view');
    var modal = document.getElementById('otp-modal');
    if (modal) modal.classList.add('otp-modal-open');

    // 2. Lock the form behind the modal
    lockForm();

    // 3. Animate steps at 0ms → 600ms → 1200ms
    [0, 1, 2].forEach(function (i) {
      setTimeout(function () {
        var prev = document.getElementById('otp-step-' + (i - 1));
        if (prev) { prev.classList.remove('active'); prev.classList.add('done'); }
        var el = document.getElementById('otp-step-' + i);
        if (el) el.classList.add('active');
      }, i * 600);
    });

    // 4. API + minimum 1800ms so the animation always completes
    var MIN_OTP_MS = 1800;
    var apiPromise = new Promise(function (resolve) {
      var fd2 = new FormData();
      fd2.append('shop', Shopify.shop);
      fd2.append('phone', phoneValue);
      $.ajax({
        url: 'https://shopifyapp.openserve.co.za/api/sendOtp',
        method: 'POST', processData: false, contentType: false,
        dataType: 'json', data: fd2, timeout: 30000
      }).done(function (res) { resolve({ ok: true, data: res }); })
        .fail(function () { resolve({ ok: false, data: null }); });
    });
    var timerPromise = new Promise(function (resolve) { setTimeout(resolve, MIN_OTP_MS); });

    Promise.all([apiPromise, timerPromise]).then(function (results) {
      var result = results[0];
      var res = result.data;

      // Finish all steps
      [0, 1, 2].forEach(function (i) {
        var el = document.getElementById('otp-step-' + i);
        if (el) { el.classList.remove('active'); el.classList.add('done'); }
      });

      if (result.ok && res && res.success) {
        // Ring turns green — brief success pause — then switch to digit input
        if (sendingView) sendingView.classList.add('otp-send-success');
        setTimeout(function () {
          clearOtpDigits();
          showOtpView('otp-input-view');
          startCountdown(60);
          setTimeout(function () { var first = document.querySelector('.otp-digit'); if (first) first.focus(); }, 100);
        }, 600);
      } else {
        var errMsg = document.getElementById('otp-send-error-msg');
        if (errMsg) errMsg.innerText = (res && res.message) || 'Failed to send OTP. Please try again.';
        showOtpView('otp-send-error-view');
      }
    });
  }

  function closeOtpModal() {
    var modal = document.getElementById('otp-modal');
    if (modal) modal.classList.remove('otp-modal-open');
    clearTimeout(otp.timer);
    clearOtpDigits();
    // Unlock the form so the user can edit fields again
    unlockForm();
  }
  function lockAltPhone(clearValue) {
    var altEl = document.getElementById('alt_phone');
    var altWaEl = document.getElementById('alt_phone_whatsapp');
    var altWrapEl = document.getElementById('alt-verified-wrap');
    var altVerBtn = document.getElementById('verify-alt-btn');
    var altHintEl = document.getElementById('alt-phone-lock-hint');
    if (altEl) { altEl.readOnly = true; if (clearValue) altEl.value = ''; }
    if (altWaEl) { altWaEl.disabled = true; if (clearValue) altWaEl.checked = false; }
    if (altWrapEl) { altWrapEl.style.display = 'none'; }
    if (altVerBtn) { altVerBtn.style.display = 'none'; }
    if (altHintEl) { altHintEl.style.display = 'block'; }
    otp.altToken = null;
  }
  function unlockAltPhone() {
    var altEl = document.getElementById('alt_phone');
    var altWaEl = document.getElementById('alt_phone_whatsapp');
    var altHintEl = document.getElementById('alt-phone-lock-hint');
    var altVerBtn = document.getElementById('verify-alt-btn');
    if (altEl) { altEl.readOnly = false; }
    if (altWaEl) { altWaEl.disabled = false; }
    if (altHintEl) { altHintEl.style.display = 'none'; }
    // Show verify button immediately if field already has a valid pre-filled number
    var val = (altEl?.value || '').trim();
    if (altVerBtn) altVerBtn.style.display = SA_PHONE_RE.test(val) ? 'inline-flex' : 'none';
  }

  function setVerified(target, token) {
    var inputEl = document.getElementById(target === 'phone' ? 'phone' : 'alt_phone');
    var wrapEl = document.getElementById(target === 'phone' ? 'phone-verified-wrap' : 'alt-verified-wrap');
    var verifyEl = document.getElementById(target === 'phone' ? 'verify-phone-btn' : 'verify-alt-btn');
    if (inputEl) { inputEl.readOnly = true; }
    if (wrapEl) { wrapEl.style.display = 'inline-flex'; }
    if (verifyEl) { verifyEl.style.display = 'none'; }
    if (target === 'phone') { otp.phoneToken = token; unlockAltPhone(); }
    else { otp.altToken = token; }
    checkSubmitReady();
  }
  function clearVerified(target) {
    var inputEl = document.getElementById(target === 'phone' ? 'phone' : 'alt_phone');
    var wrapEl = document.getElementById(target === 'phone' ? 'phone-verified-wrap' : 'alt-verified-wrap');
    var verifyEl = document.getElementById(target === 'phone' ? 'verify-phone-btn' : 'verify-alt-btn');
    if (inputEl) { inputEl.readOnly = false; inputEl.focus(); }
    if (wrapEl) { wrapEl.style.display = 'none'; }
    if (verifyEl) { verifyEl.style.display = 'inline-flex'; }
    if (target === 'phone') { otp.phoneToken = null; lockAltPhone(true); }
    else { otp.altToken = null; }
    checkSubmitReady();
  }

  // Build getDocument API call
  var fd = new FormData();
  var _cid = (window.customerId && window.customerId !== 'undefined' && window.customerId !== 'null') ? window.customerId : '';
  fd.append('customer_id', _cid);
  fd.append('shop', Shopify.shop);

  var apiPromise = new Promise(function (resolve) {
    $.ajax({
      url: 'https://shopifyapp.openserve.co.za/api/getDocument',
      method: 'POST', processData: false, contentType: false,
      mimeType: 'multipart/form-data', dataType: 'json',
      data: fd, timeout: 0
    }).done(function (resp) { resolve({ ok: true, data: resp }); })
      .fail(function () { resolve({ ok: false, data: null }); });
  });
  var timerPromise = new Promise(function (resolve) { setTimeout(resolve, MIN_SPLASH_MS); });

  Promise.all([apiPromise, timerPromise])
    .then(function (results) {
      var result = results[0];
      var response = result.data;

      splashSuccess(function () {
        // API failed — reveal form so user is never blocked
        if (!result.ok || !response) {
          revealRicaForm();
          return;
        }
        // Flow B: RICA fully verified (metafield is string 'true') + came from PDP
        if (window.customer_hasSubmitted === 'true' && window.getCookie('login_button_click')) {
          var url = window.getCookie('login_button_click');
          window.setCookie('login_button_click', '', 0);
          if (typeof window.osShowCheckoutPopup === 'function') {
            window.osShowCheckoutPopup(url);
          } else {
            window.location.href = url;
          }
          return;
        }
        // Flow B2: RICA record exists + rica-submitted tag present + came from PDP/PLP
        // No tag = show form so customer can re-submit and get the tag added
        if (response.success && window.ricaSubmitted && window.getCookie('login_button_click')) {
          var url = window.getCookie('login_button_click');
          window.setCookie('login_button_click', '', 0);
          if (typeof window.osShowCheckoutPopup === 'function') {
            window.osShowCheckoutPopup(url);
          } else {
            window.location.href = url;
          }
          return;
        }
        // Flow A / C: reveal form
        revealRicaForm();
        // Pre-fill if existing record.
        // OTP customers are NOT prefilled from getDocument — it's keyed on the
        // Shopify customer_id which they don't have, so it can return another
        // customer's record. They're prefilled from the phone-scoped
        // rica-profile call above instead. Only legacy (Shopify-login) stores
        // use this getDocument-based prefill.
        var osIsOtpCustomer = !!(window.osCustomer && window.osCustomer.loggedIn);
        if (response.success && response.data && !osIsOtpCustomer) {
          var d = response.data;
          var setVal = function (id, val) { var el = document.getElementById(id); if (el && val != null) el.value = val; };
          setVal('first_name', d.first_name); setVal('last_name', d.last_name);
          setVal('phone', d.phone); setVal('alt_phone', d.alt_phone);
          setVal('id_type', d.id_type); setVal('id_number', d.id_number);
          var phoneWa = document.getElementById('phone_whatsapp');
          var altWa = document.getElementById('alt_phone_whatsapp');
          if (phoneWa) phoneWa.checked = d.phone_whatsapp === 1;
          if (altWa) altWa.checked = d.alt_phone_whatsapp === 1;
          document.getElementById('id_type')?.dispatchEvent(new Event('change'));
          var notice = document.querySelector('.form-success-response.rds-success');
          if (notice) {
            notice.innerText = 'Account successfully created.';
            notice.style.background = '#ebf8ff';
            notice.style.color = '#2b6cb0';
            notice.style.borderColor = '#90cdf4';
            notice.style.display = 'block';
          }
          // Auto-verify phones already on record — skips OTP if number unchanged
          if (d.phone_preauth_token && d.phone) {
            setVerified('phone', d.phone_preauth_token);
          }
          if (d.alt_phone_preauth_token && d.alt_phone) {
            setVerified('alt_phone', d.alt_phone_preauth_token);
          }
          // setVerified calls checkSubmitReady internally; only call directly if no token
          if (!d.phone_preauth_token) checkSubmitReady();
        }
      });
    });

  // ── OTP Event Listeners ─────────────────────────────────────────────
  var verifyPhoneBtn = document.getElementById('verify-phone-btn');
  if (verifyPhoneBtn) {
    verifyPhoneBtn.addEventListener('click', function () {
      var val = (document.getElementById('phone')?.value || '').trim();
      if (!SA_PHONE_RE.test(val)) { showFormBanner('Please enter a valid SA mobile number before verifying.', 'error'); return; }
      openOtpModal('phone', val);
    });
  }
  var verifyAltBtn = document.getElementById('verify-alt-btn');
  if (verifyAltBtn) {
    verifyAltBtn.addEventListener('click', function () {
      var val = (document.getElementById('alt_phone')?.value || '').trim();
      var mainVal = (document.getElementById('phone')?.value || '').trim();
      if (!SA_PHONE_RE.test(val)) { showFormBanner('Please enter a valid SA mobile number before verifying.', 'error'); return; }
      if (val === mainVal) { showFormBanner('Alternate number must be different from your mobile number.', 'error'); return; }
      openOtpModal('alt_phone', val);
    });
  }
  var otpModalCloseBtn = document.getElementById('otp-modal-close');
  if (otpModalCloseBtn) otpModalCloseBtn.addEventListener('click', closeOtpModal);
  var otpModalEl = document.getElementById('otp-modal');
  if (otpModalEl) otpModalEl.addEventListener('click', function (e) { if (e.target === otpModalEl) closeOtpModal(); });

  // Retry button — re-fires sendOtp with the same phone while keeping modal open
  var otpRetryBtn = document.getElementById('otp-retry-btn');
  if (otpRetryBtn) {
    otpRetryBtn.addEventListener('click', function () {
      var inputId = otp.target === 'phone' ? 'phone' : 'alt_phone';
      var phoneVal = (document.getElementById(inputId)?.value || '').trim();
      openOtpModal(otp.target, phoneVal);
    });
  }
  var phoneChangeLinkEl = document.getElementById('phone-change-link');
  if (phoneChangeLinkEl) phoneChangeLinkEl.addEventListener('click', function () { clearVerified('phone'); });
  var altChangeLinkEl = document.getElementById('alt-change-link');
  if (altChangeLinkEl) altChangeLinkEl.addEventListener('click', function () { clearVerified('alt_phone'); });

  var phoneInputEl = document.getElementById('phone');
  if (phoneInputEl) {
    phoneInputEl.addEventListener('input', function () {
      if (otp.phoneToken) clearVerified('phone');
      checkSubmitReady();
    });
  }
  var altPhoneInputEl = document.getElementById('alt_phone');
  if (altPhoneInputEl) {
    altPhoneInputEl.addEventListener('input', function () {
      var val = (this.value || '').trim();
      var btn = document.getElementById('verify-alt-btn');
      if (btn) btn.style.display = SA_PHONE_RE.test(val) ? 'inline-flex' : 'none';
      if (otp.altToken) clearVerified('alt_phone');
      checkSubmitReady();
    });
  }

  var otpDigits = document.querySelectorAll('.otp-digit');
  otpDigits.forEach(function (el, idx) {
    el.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(-1);
      if (this.value && idx < otpDigits.length - 1) otpDigits[idx + 1].focus();
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Backspace' && !this.value && idx > 0) otpDigits[idx - 1].focus();
    });
    el.addEventListener('paste', function (e) {
      e.preventDefault();
      var text = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');
      otpDigits.forEach(function (d, i) { d.value = text[i] || ''; });
      if (text.length >= 6) otpDigits[5].focus();
      else if (text.length) otpDigits[Math.min(text.length, 5)].focus();
    });
  });

  var otpConfirmBtn = document.getElementById('otp-confirm-btn');
  if (otpConfirmBtn) {
    otpConfirmBtn.addEventListener('click', function () {
      var code = otpDigitsValue();
      if (code.length < 6) {
        var errEl = document.getElementById('otp-error-msg');
        if (errEl) errEl.innerText = 'Please enter all 6 digits.';
        return;
      }
      otpConfirmBtn.disabled = true; otpConfirmBtn.innerText = 'Verifying\u2026';
      var phoneVal = (document.getElementById(otp.target === 'phone' ? 'phone' : 'alt_phone')?.value || '').trim();
      var fd3 = new FormData();
      fd3.append('shop', Shopify.shop);
      fd3.append('phone', phoneVal);
      fd3.append('otp_code', code);
      $.ajax({
        url: 'https://shopifyapp.openserve.co.za/api/verifyOtp',
        method: 'POST', processData: false, contentType: false,
        dataType: 'json', data: fd3, timeout: 30000
      }).done(function (res) {
        otpConfirmBtn.disabled = false; otpConfirmBtn.innerText = 'Confirm OTP';
        if (res && res.success) {
          closeOtpModal();
          setVerified(otp.target, res.verified_token);
        } else {
          document.querySelectorAll('.otp-digit').forEach(function (d) { d.classList.add('otp-error'); });
          var errEl = document.getElementById('otp-error-msg');
          if (errEl) errEl.innerText = res.message || 'Incorrect OTP. Please try again.';
          if (res && res.remaining === 0) setTimeout(closeOtpModal, 1500);
        }
      }).fail(function () {
        otpConfirmBtn.disabled = false; otpConfirmBtn.innerText = 'Confirm OTP';
        var errEl = document.getElementById('otp-error-msg');
        if (errEl) errEl.innerText = 'Network error. Please try again.';
      });
    });
  }

  // Enable/disable submit — requires consent + phone verified (+ alt if entered)
  const consentCheckbox = document.getElementById('consent');
  if (consentCheckbox) {
    consentCheckbox.addEventListener('change', checkSubmitReady);
  }

  // Add submit event listener to the form
  form?.addEventListener('submit', function (event) {
    event.preventDefault();
    // Hard guard — block submission if consent is not checked (covers Enter key bypass)
    const consentEl = document.getElementById('consent');
    if (!consentEl || !consentEl.checked) {
      const errEl = document.querySelector('.consent-error');
      if (errEl) errEl.innerText = 'You must accept the consent to proceed.';
      errEl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const submitBtn = document.querySelector('.rds-submit-btn');
    const main_loader = submitBtn?.querySelector('.rds-loader');
    const btnText = submitBtn?.querySelector('.rds-btn-text');
    // Disable button and show inline spinner immediately
    if (submitBtn) { submitBtn.disabled = true; }
    if (btnText) { btnText.style.display = 'none'; }
    if (main_loader) { main_loader.style.display = 'inline-block'; }
    // Disable Explore button while submitting so user can't navigate away mid-request
    var exploreBtnEl = document.getElementById('rds-explore-btn');
    if (exploreBtnEl) exploreBtnEl.setAttribute('aria-disabled', 'true');

    var get_formData = new FormData(form);
    const formdata = new FormData();
    // Guard customer_id — avoid sending the literal string "undefined" to the backend
    const _customerId = (window.customerId && window.customerId !== 'undefined' && window.customerId !== 'null')
      ? window.customerId : '';
    formdata.append("shop", Shopify.shop);
    formdata.append("customer_id", _customerId);
    formdata.append("name", (get_formData.get('first_name') + ' ' + get_formData.get('last_name')).trim());
    formdata.append("first_name", get_formData.get('first_name'));
    formdata.append("last_name", get_formData.get('last_name'));
    formdata.append("email", get_formData.get('email'));
    formdata.append("consent", get_formData.get('consent'));

    // Phones
    formdata.append("phone", get_formData.get('phone'));
    formdata.append("alt_phone", get_formData.get('alt_phone'));
    formdata.append("phone_whatsapp", get_formData.get('phone_whatsapp') ? 1 : 0);
    formdata.append("alt_phone_whatsapp", get_formData.get('alt_phone_whatsapp') ? 1 : 0);
    formdata.append("phone_token", otp.phoneToken || '');
    var _altPhoneVal = (get_formData.get('alt_phone') || '').trim();
    if (_altPhoneVal) formdata.append("alt_phone_token", otp.altToken || '');

    // Identity
    formdata.append("id_type", get_formData.get('id_type'));
    formdata.append("id_number", get_formData.get('id_number'));

    // Communication
    //formdata.append("communication_method", get_formData.get('communication_method'));

    // ── Validation ──────────────────────────────────────────────
    const phoneRegex = /^(\+27|27|0)[6-8][0-9]{8}$/;
    const emailRegex = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/;
    let hasError = false;
    let firstErrEl = null;

    function showError(selector, message) {
      const el = document.querySelector(selector);
      if (!el) return;
      el.innerText = message;
      if (!firstErrEl) firstErrEl = el;
    }
    function clearError(selector) {
      const el = document.querySelector(selector);
      if (el) el.innerText = '';
    }

    // Reset all inline errors first
    ['.email-form-error', '.first-name-error', '.last-name-error',
      '.phone-form-error', '.alt-phone-form-error',
      '.id-type-error', '.id-number-error', '.consent-error'].forEach(clearError);

    // First Name
    if (!get_formData.get('first_name')?.trim()) {
      showError('.first-name-error', 'Please enter your first name.');
      hasError = true;
    }

    // Last Name
    if (!get_formData.get('last_name')?.trim()) {
      showError('.last-name-error', 'Please enter your last name.');
      hasError = true;
    }

    // Email
    if (!emailRegex.test(get_formData.get('email'))) {
      showError('.email-form-error', 'Please enter a valid email address (e.g. name@example.com).');
      hasError = true;
    }

    // Mobile number
    if (!phoneRegex.test(get_formData.get('phone'))) {
      showError('.phone-form-error', 'Please enter a valid South African mobile number (e.g. 0821234567 or +27821234567).');
      hasError = true;
    }

    // Alternate number — only if provided
    const altPhoneVal = get_formData.get('alt_phone');
    if (altPhoneVal && altPhoneVal.trim() !== '') {
      if (!phoneRegex.test(altPhoneVal)) {
        showError('.alt-phone-form-error', 'The alternate number is not a valid South African number. Please correct it or leave the field empty.');
        hasError = true;
      }
    }

    // ID Type
    if (!get_formData.get('id_type')) {
      showError('.id-type-error', 'Please select your ID document type to continue.');
      hasError = true;
    }

    // ID Number
    const idNumber = get_formData.get('id_number')?.trim();
    const idType = get_formData.get('id_type');
    if (!idNumber) {
      showError('.id-number-error', 'Please enter your ID or passport number.');
      hasError = true;
    } else if (idType === 'sa_id') {
      if (!isValidSAID(idNumber)) {
        showError('.id-number-error', 'This SA ID number does not appear to be valid. Please double-check the 13-digit number on your ID book or smart card.');
        hasError = true;
      }
    }

    // Consent
    if (!get_formData.get('consent')) {
      showError('.consent-error', 'You must agree to the consent statement before your application can be submitted.');
      hasError = true;
    }

    // Scroll to first error
    if (firstErrEl) {
      firstErrEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (hasError) {
      if (main_loader) { main_loader.style.display = 'none'; }
      if (btnText) { btnText.style.display = 'inline'; }
      if (submitBtn) { submitBtn.disabled = false; }
      return;
    }
    // ── End Validation ───────────────────────────────────────────
    // ── End Validation ───────────────────────────────────────────
    const settings = {
      "url": "https://shopifyapp.openserve.co.za/api/submitDocument",
      "method": "POST",
      "timeout": 0,
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "dataType": "json",
      "data": formdata
    };
    let message_display = document.querySelector('.rds-success');
    $.ajax(settings).done(function (response) {
      console.log('response', response);
      if (!response.success) {
        // Map known backend messages to user-friendly text
        var backendMsgMap = {
          'Consent must be selected': 'You must agree to the consent statement before your application can be submitted.',
          'An error occurred while saving your submission. Please try again.': 'We were unable to save your submission at this time. Please try again in a few moments. If the issue continues, contact our support team.',
          'Mobile number OTP verification is required before submitting.': 'Please verify your mobile number via WhatsApp OTP before submitting.',
          'Alternate number OTP verification is required before submitting.': 'Please verify your alternate number via WhatsApp OTP before submitting.',
        };
        var failMsg = backendMsgMap[response.message] || response.message || 'We could not process your submission. Please review your details and try again.';
        message_display.innerText = failMsg;
        message_display.style.background = '#fff5f5';
        message_display.style.color = '#c53030';
        message_display.style.borderColor = '#fc8181';
        message_display.style.display = 'block';
        message_display.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (main_loader) { main_loader.style.display = 'none'; }
        if (btnText) { btnText.style.display = 'inline'; }
        if (submitBtn) { submitBtn.disabled = false; }
        return;
      }
      // Success — reset to green styling in case banner was previously red
      message_display.innerText = 'Account created successfully.';
      message_display.style.background = '#f0fff4';
      message_display.style.color = '#276749';
      message_display.style.borderColor = '#9ae6b4';
      message_display.style.display = 'block';
      message_display.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (main_loader) { main_loader.style.display = 'none'; }
      if (btnText) { btnText.style.display = 'inline'; }
      // Reset consent + re-disable button so user cannot re-submit without re-ticking consent
      const consentChk = document.getElementById('consent');
      if (consentChk) { consentChk.checked = false; }
      if (submitBtn) { submitBtn.disabled = true; }
      // after submit function call — pass true so the notice banner is not overwritten
      theme.rica_after_submit(true);
      if (window.getCookie('login_button_click')) {
        // PDP/PLP flow — redirect to SF checkout for the plan they were subscribing to
        setTimeout(() => {
          let url_redirect = window.getCookie('login_button_click');
          window.setCookie('login_button_click', '', 0);
          // Strip any stale ai_* customer-detail params already on this URL
          // (stamped on page load from the pre-RICA profile fetch) before
          // appending the just-submitted values below — otherwise each
          // param ends up duplicated on the URL SF receives.
          url_redirect = osStripAiCustomerParams(url_redirect);
          // Append the customer details just submitted on this RICA form —
          // not available at the time the SF checkout URL was first built.
          var firstName = get_formData.get('first_name');
          var lastName  = get_formData.get('last_name');
          var email     = get_formData.get('email');
          var phone     = get_formData.get('phone');
          var freshParams = '';
          if (firstName) freshParams += `&ai_firstName=${encodeURIComponent(firstName)}`;
          if (lastName)  freshParams += `&ai_lastName=${encodeURIComponent(lastName)}`;
          if (email)     freshParams += `&ai_email=${encodeURIComponent(email)}`;
          if (phone)     freshParams += `&ai_phone=${encodeURIComponent(osNormalizePhoneE164(phone))}`;
          url_redirect = osAppendParams(url_redirect, freshParams);
          if (typeof window.osShowCheckoutPopup === 'function') {
            // RICA-after-submit popup: Cancel sends the customer to /collections/all.
            window.osShowCheckoutPopup(url_redirect, '/collections/all');
          } else {
            window.location.href = url_redirect;
          }
        }, 1000);
      } else {
        // Direct visit — show Explore Fibre Packages button (only if not already visible)
        var exploreWrap = document.getElementById('rds-explore-wrap');
        var exploreBtnEl = document.getElementById('rds-explore-btn');
        if (exploreWrap && exploreWrap.style.display !== 'block') {
          exploreWrap.style.display = 'block';
        }
        if (exploreBtnEl) exploreBtnEl.removeAttribute('aria-disabled');
      }
    })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error("API call failed: ", textStatus, errorThrown);
        if (main_loader) { main_loader.style.display = 'none'; }
        if (btnText) { btnText.style.display = 'inline'; }
        if (submitBtn) { submitBtn.disabled = false; }
        // Re-enable Explore button if it was visible before submit
        var exploreBtnEl = document.getElementById('rds-explore-btn');
        if (exploreBtnEl) exploreBtnEl.removeAttribute('aria-disabled');

        // Helper: show red banner
        var showBanner = function (text) {
          if (!message_display) return;
          message_display.innerText = text;
          message_display.style.background = '#fff5f5';
          message_display.style.color = '#c53030';
          message_display.style.borderColor = '#fc8181';
          message_display.style.display = 'block';
          message_display.scrollIntoView({ behavior: 'smooth', block: 'center' });
        };

        // Status-based default messages
        var httpStatus = jqXHR.status;
        var defaultMsg =
          textStatus === 'timeout' ? 'The request took too long to complete. Please check your internet connection and try again.' :
            textStatus === 'abort' ? 'The request was cancelled. Please try submitting again.' :
              !httpStatus ? 'Unable to reach the server. Please check your internet connection and try again.' :
                httpStatus === 422 ? 'Some of your details could not be validated. Please review the highlighted fields and correct any errors.' :
                  httpStatus === 429 ? 'Too many requests. Please wait a moment before trying again.' :
                    httpStatus >= 500 ? 'We experienced a technical issue on our end. Please try again in a few moments. If the problem persists, contact our support team.' :
                      'Something went wrong while submitting your application. Please try again.';

        var fieldSelectorMap = {
          phone: '.phone-form-error',
          email: '.email-form-error',
          alt_phone: '.alt-phone-form-error',
          id_type: '.id-type-error',
          id_number: '.id-number-error',
          first_name: '.first-name-error',
          last_name: '.last-name-error',
          consent: '.consent-error',
        };

        try {
          var jsonResponse = JSON.parse(jqXHR.responseText);
          var msg = jsonResponse && jsonResponse.message;

          if (msg && typeof msg === 'object') {
            // Laravel 422 — map each field error to its inline element
            var shownOnField = false;
            Object.keys(fieldSelectorMap).forEach(function (field) {
              var err = msg[field];
              if (err) {
                var text = Array.isArray(err) ? err[0] : err;
                showError(fieldSelectorMap[field], text);
                shownOnField = true;
              }
            });
            var firstErr = document.querySelector('.rds-error:not(:empty)');
            if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Unknown field errors — show in banner
            if (!shownOnField) {
              var unknownFields = Object.keys(msg).filter(function (k) { return !fieldSelectorMap[k]; });
              var firstUnknown = unknownFields.length ? (Array.isArray(msg[unknownFields[0]]) ? msg[unknownFields[0]][0] : msg[unknownFields[0]]) : null;
              showBanner(firstUnknown || defaultMsg);
            }
          } else if (typeof msg === 'string' && msg.length) {
            // Plain string message from backend (e.g. 500 error)
            showBanner(msg);
          } else {
            showBanner(defaultMsg);
          }
        } catch (e) {
          console.error('Failed to parse error response', e);
          showBanner(defaultMsg);
        }
      });
  })
}

function isValidSAID(id) {
  if (!/^[0-9]{13}$/.test(id)) return false;

  let sum = 0;
  for (let i = 0; i < 12; i++) {
    let digit = parseInt(id[i]);
    if (i % 2 === 0) {
      sum += digit;
    } else {
      let temp = digit * 2;
      sum += temp > 9 ? temp - 9 : temp;
    }
  }
  let check = (10 - (sum % 10)) % 10;
  return check === parseInt(id[12]);
}

function validateFileSize(input) {
  const maxFileSize = 2 * 1024 * 1024; // 2 MB (in bytes)
  let document_error = input.parentElement.querySelector('.form-error');
  if (input.files && input.files[0]) {
    const fileSize = input.files[0].size;
    if (fileSize > maxFileSize) {
      document_error.innerText = "File size exceeds the maximum limit of 2MB";
      input.value = ''; // Clear the file input
    } else {
      document_error.innerText = ' ';
    }
  }
}
theme.rica_after_submit = function (afterSubmit) {
  const formdata = new FormData();
  const _afterCustomerId = (window.customerId && window.customerId !== 'undefined' && window.customerId !== 'null')
    ? window.customerId : '';
  formdata.append("customer_id", _afterCustomerId);
  formdata.append("shop", Shopify.shop);
  console.log('formdata', formdata);
  const settings = {
    "url": "https://shopifyapp.openserve.co.za/api/getDocument",
    "method": "POST",
    "timeout": 0,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    "dataType": "json",
    "data": formdata
  };
  $.ajax(settings).done(function (response) {
    console.log('response', response);
    if (response.success == true) {
      if (window.location.pathname.includes('document-submit')) {
        // Pre-fill the form with previously submitted data
        const d = response.data;
        const setVal = (id, val) => { const el = document.getElementById(id); if (el && val != null) el.value = val; };
        setVal('first_name', d.first_name);
        setVal('last_name', d.last_name);
        setVal('phone', d.phone);
        setVal('alt_phone', d.alt_phone);
        setVal('id_type', d.id_type);
        setVal('id_number', d.id_number);
        const phoneWa = document.getElementById('phone_whatsapp');
        const altPhoneWa = document.getElementById('alt_phone_whatsapp');
        if (phoneWa) phoneWa.checked = d.phone_whatsapp === 1;
        if (altPhoneWa) altPhoneWa.checked = d.alt_phone_whatsapp === 1;
        // Fire id_type change so the hint text updates
        document.getElementById('id_type')?.dispatchEvent(new Event('change'));
        // Show previously submitted notice only on page load, not after a fresh re-submit
        if (!afterSubmit) {
          let notice = document.querySelector('.form-success-response.rds-success');
          if (notice) {
            notice.innerText = 'Account successfully created.';
            notice.style.background = '#ebf8ff';
            notice.style.color = '#2b6cb0';
            notice.style.borderColor = '#90cdf4';
            notice.style.display = 'block';
          }
        }
      } else if (document.body.classList.contains('template-account')) {
        let updated_text = `<div class="text form-filled" style="color: #e89528;font-weight: 600;">${response.message}</div>
                            <div class="button-url"><a href="/pages/document-submit" class="button">View Detail</a></div>`
        document.querySelector('.text-btn-wrap').innerHTML = updated_text;
      } else if (document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')) {
        console.log("pdpppp");
        setTimeout(() => {
          document.querySelectorAll('.no-customer-error').forEach(function (item) {
            item.innerHTML = `<a href="/pages/document-submit" style="color: #e89528;font-weight: 600;text-decoration:none;"> Under verification</a>`;
          });
        }, 1000);
      }
    }
  })
}
/* ─────────────────────────────────────────────────────────────────────────
   ID Document Upload Page  (/pages/upload-document)
   ───────────────────────────────────────────────────────────────────────── */
theme.upload_document = function () {

  const API_BASE = 'https://shopifyapp.openserve.co.za/api';
  const customerId = (window.customerId && window.customerId !== 'undefined' && window.customerId !== 'null')
    ? window.customerId : '';
  const shop = Shopify.shop;
  // OTP stores have no Shopify customer id — fetch/upload the document by the
  // customer's own JWT (phone-scoped) instead of the customer_id endpoints.
  const osIsOtp = !!(window.osCustomer && window.osCustomer.loggedIn);

  const ID_TYPE_LABELS = {
    'sa_id': 'South African ID',
    'sa_passport': 'South African Passport',
    'foreign_passport': 'Foreign Passport',
  };

  // DOM refs
  const loadingEl = document.getElementById('upl-loading');
  const formContentEl = document.getElementById('upl-form-content');
  const idTypeLabelEl = document.getElementById('upl-id-type-label');
  const uploadTitleEl = document.getElementById('upl-upload-title');
  const currentDocSec = document.getElementById('upl-current-doc');
  const currentDivider = document.getElementById('upl-divider-current');
  const currentPreview = document.getElementById('upl-current-preview');
  const currentDocName = document.getElementById('upl-current-doc-name');
  const currentDocDate = document.getElementById('upl-current-doc-date');
  const currentDocLink = document.getElementById('upl-current-doc-link');
  const dropzone = document.getElementById('upl-dropzone');
  const fileInput = document.getElementById('upl-id-document');
  const fileSelected = document.getElementById('upl-file-selected');
  const fileThumbWrap = document.getElementById('upl-file-thumb-wrap');
  const fileNameEl = document.getElementById('upl-file-name');
  const fileSizeEl = document.getElementById('upl-file-size');
  const fileRemoveBtn = document.getElementById('upl-file-remove');
  const docError = document.getElementById('upl-doc-error');
  const messageEl = document.getElementById('upl-message');
  const statusBanner = document.getElementById('upl-status-banner');
  const uploadingForWrap = document.getElementById('upl-uploading-for');
  const uploadingForLabel = document.getElementById('upl-uploading-for-label');
  const form = document.getElementById('upl-document-form');
  const submitBtn = form ? form.querySelector('.rds-submit-btn') : null;
  const btnText = form ? form.querySelector('.upl-btn-text') : null;
  const btnLoader = form ? form.querySelector('.rds-loader') : null;

  // ── Helpers ────────────────────────────────────────────────────────────

  function formatBytes(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / 1048576).toFixed(1) + ' MB';
  }

  function showMessage(text, type) {
    // type: 'success' | 'error'
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.className = 'upl-message upl-' + type;
    messageEl.style.display = 'block';
    messageEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideMessage() {
    if (!messageEl) return;
    messageEl.style.display = 'none';
    messageEl.textContent = '';
    messageEl.className = 'upl-message';
  }

  function setSubmitLoading(on) {
    if (submitBtn) submitBtn.disabled = on;
    if (btnText) btnText.style.display = on ? 'none' : 'inline';
    if (btnLoader) btnLoader.style.display = on ? 'inline-block' : 'none';
  }

  function buildDocPreview(url, isImage) {
    if (isImage) {
      const img = document.createElement('img');
      img.src = url;
      img.alt = 'ID Document';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
      return img;
    }
    // PDF icon
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '28'); svg.setAttribute('height', '28');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', '#e53e3e'); svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
    svg.innerHTML = '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>'
      + '<polyline points="14 2 14 8 20 8"/>'
      + '<line x1="16" y1="13" x2="8" y2="13"/>'
      + '<line x1="16" y1="17" x2="8" y2="17"/>';
    return svg;
  }

  function updateCurrentDocSection(url, uploadedOn) {
    if (!url) return;
    const isImage = /\.(jpg|jpeg|png)$/i.test(url);
    const fileName = url.split('/').pop();

    // Thumb / icon
    if (currentPreview) {
      currentPreview.innerHTML = '';
      currentPreview.appendChild(buildDocPreview(url, isImage));
    }
    if (currentDocName) currentDocName.textContent = fileName;
    if (currentDocDate && uploadedOn) currentDocDate.textContent = 'Uploaded ' + uploadedOn;
    if (currentDocLink) { currentDocLink.href = url; }

    if (currentDocSec) currentDocSec.style.display = 'block';
    if (currentDivider) currentDivider.style.display = 'block';
    if (uploadTitleEl) uploadTitleEl.textContent = 'Replace Document';
  }

  // ── Step 1: Fetch existing record on page load ─────────────────────────

  var docFetch;
  if (osIsOtp) {
    docFetch = fetch(API_BASE + '/customer/document', {
      headers: { 'Authorization': 'Bearer ' + OsSession.get() }
    }).then(function (r) { return r.json(); });
  } else {
    var fd = new FormData();
    fd.append('customer_id', customerId);
    fd.append('shop', shop);
    docFetch = new Promise(function (resolve, reject) {
      $.ajax({
        url: API_BASE + '/getDocument',
        method: 'POST',
        processData: false,
        contentType: false,
        mimeType: 'multipart/form-data',
        dataType: 'json',
        data: fd,
      }).done(resolve).fail(reject);
    });
  }

  docFetch.then(function (response) {

    if (!response.success) {
      // No RICA record — send customer to RICA form first
      window.location.href = '/pages/document-submit';
      return;
    }

    const d = response.data;

    // ── Populate id_type label (badge at top of form) ──────────────────
    var idTypeHuman = ID_TYPE_LABELS[d.id_type] || d.id_type || 'Not specified';
    if (idTypeLabelEl) {
      idTypeLabelEl.textContent = idTypeHuman;
    }

    // ── "Uploading for" label — shown directly above the dropzone ──────
    if (uploadingForLabel) uploadingForLabel.textContent = idTypeHuman;
    if (uploadingForWrap) uploadingForWrap.style.display = 'flex';

    // ── Colour-coded document status banner ────────────────────────────
    var statusLabel = d.status_label || 'pending';

    if (statusLabel === 'approved') {
      // Document approved — show success banner and LOCK the upload form
      if (statusBanner) {
        statusBanner.className = 'upl-status-approved';
        statusBanner.innerHTML =
          '<div class="upl-status-icon">'
          + '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#276749" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>'
          + '<div class="upl-status-text">'
          + '<div class="upl-status-title">Your ID document has been approved</div>'
          + '<div>Your identity has been successfully verified. No further action is required.</div>'
          + '</div></div>';
        statusBanner.style.display = 'block';
      }
      // Hide the entire upload form — no re-upload allowed when approved
      if (form) form.style.display = 'none';
      if (currentDocSec) currentDocSec.style.display = 'none';
      if (currentDivider) currentDivider.style.display = 'none';
      if (uploadingForWrap) uploadingForWrap.style.display = 'none';

    } else if (statusLabel === 'rejected') {
      // Document rejected — show rejection banner but KEEP form visible for re-upload
      var rejectionNote = d.rejection_reason
        ? '<div style="margin-top:6px;font-size:13px;opacity:0.85;">Reason: ' + d.rejection_reason + '</div>'
        : '';
      if (statusBanner) {
        statusBanner.className = 'upl-status-rejected';
        statusBanner.innerHTML =
          '<div class="upl-status-icon">'
          + '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#c53030" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
          + '<div class="upl-status-text">'
          + '<div class="upl-status-title">Your ID document was not approved</div>'
          + '<div>Please upload a new, clear copy of your ' + idTypeHuman + '.' + rejectionNote + '</div>'
          + '</div></div>';
        statusBanner.style.display = 'block';
      }
      // Update section title to make re-upload intent clear
      if (uploadTitleEl) uploadTitleEl.textContent = 'Upload New Document';

    } else {
      // Pending — only show the banner if a document has already been submitted
      if (d.id_document && statusBanner) {
        statusBanner.className = 'upl-status-pending';
        statusBanner.innerHTML =
          '<div class="upl-status-icon">'
          + '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7d5a00" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
          + '<div class="upl-status-text">'
          + '<div class="upl-status-title">Your document is under review</div>'
          + '<div>Our team is verifying your identity document. We will notify you once the review is complete.</div>'
          + '</div></div>';
        statusBanner.style.display = 'block';
      }
    }

    // ── Show existing document preview ─────────────────────────────────
    if (d.id_document) {
      updateCurrentDocSection(d.id_document, d.created_at || null);
    }

    // ── Reveal form content, hide loader ───────────────────────────────
    if (loadingEl) loadingEl.style.display = 'none';
    if (formContentEl) formContentEl.style.display = 'block';

  }).catch(function () {
    window.location.href = '/pages/document-submit';
  });

  // ── Step 2: Drag-and-drop events on the dropzone ───────────────────────

  if (dropzone) {
    dropzone.addEventListener('dragover', function (e) {
      e.preventDefault();
      dropzone.classList.add('drag-over');
    });
    dropzone.addEventListener('dragleave', function () {
      dropzone.classList.remove('drag-over');
    });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('drag-over');
      if (e.dataTransfer.files.length) {
        fileInput.files = e.dataTransfer.files;
        fileInput.dispatchEvent(new Event('change'));
      }
    });
  }

  // ── Step 3: File selection → preview ──────────────────────────────────

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      const file = this.files[0];
      if (!file) return;

      // Clear any previous error / message
      if (docError) docError.textContent = '';
      hideMessage();

      // Client-side size guard (2 MB)
      if (file.size > 2 * 1024 * 1024) {
        if (docError) docError.textContent = 'File exceeds the 2 MB limit. Please choose a smaller file.';
        this.value = '';
        return;
      }

      // Populate file info
      if (fileNameEl) fileNameEl.textContent = file.name;
      if (fileSizeEl) fileSizeEl.textContent = formatBytes(file.size);

      // Build thumb
      if (fileThumbWrap) {
        fileThumbWrap.innerHTML = '';
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = function (ev) {
            const img = document.createElement('img');
            img.src = ev.target.result;
            img.alt = file.name;
            img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
            fileThumbWrap.appendChild(img);
          };
          reader.readAsDataURL(file);
        } else {
          // PDF — show small icon
          fileThumbWrap.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>';
        }
      }

      if (fileSelected) fileSelected.style.display = 'flex';
      if (submitBtn) submitBtn.disabled = false;
    });
  }

  // Remove selected file
  if (fileRemoveBtn) {
    fileRemoveBtn.addEventListener('click', function () {
      if (fileInput) fileInput.value = '';
      if (fileSelected) fileSelected.style.display = 'none';
      if (fileThumbWrap) fileThumbWrap.innerHTML = '';
      if (submitBtn) submitBtn.disabled = true;
      if (docError) docError.textContent = '';
    });
  }

  // ── Step 4: Form submission ────────────────────────────────────────────

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideMessage();

      const file = fileInput ? fileInput.files[0] : null;
      if (!file) {
        if (docError) docError.textContent = 'Please select a document to upload.';
        return;
      }

      setSubmitLoading(true);

      const uploadFd = new FormData();
      uploadFd.append('id_document', file);

      var uploadReq;
      if (osIsOtp) {
        // Phone-scoped upload — the JWT identifies the customer's own record.
        uploadReq = fetch(API_BASE + '/customer/document', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + OsSession.get() },
          body: uploadFd,
        }).then(function (r) { return r.json(); });
      } else {
        uploadFd.append('shop', shop);
        uploadFd.append('customer_id', customerId);
        uploadReq = new Promise(function (resolve, reject) {
          $.ajax({
            url: API_BASE + '/uploadIdDocument',
            method: 'POST',
            processData: false,
            contentType: false,
            mimeType: 'multipart/form-data',
            dataType: 'json',
            data: uploadFd,
          }).done(resolve).fail(reject);
        });
      }

      uploadReq.then(function (response) {
        setSubmitLoading(false);

        if (!response.success) {
          showMessage(response.message || 'Upload failed. Please try again.', 'error');
          if (submitBtn) submitBtn.disabled = false;
          return;
        }

        // ── Success ──
        showMessage(response.message || 'Document uploaded successfully!', 'success');

        // Update the "current document" section with the newly uploaded file
        if (response.data && response.data.id_document_url) {
          updateCurrentDocSection(response.data.id_document_url, null);
        }

        // The upload is in, so the way out stops being a quiet escape hatch
        // and becomes the obvious next step. Without this the customer is
        // left on a form they have already finished with, reading a green
        // message and guessing what to do.
        var backBtn = document.getElementById('upl-back-btn');
        if (backBtn) {
          backBtn.classList.add('is-next-step');
          var backText = backBtn.querySelector('.upl-back-text');
          if (backText) backText.textContent = 'View my documents';
        }

        // Reset the upload zone — customer must re-select to upload again
        if (fileInput) fileInput.value = '';
        if (fileSelected) fileSelected.style.display = 'none';
        if (fileThumbWrap) fileThumbWrap.innerHTML = '';
        // Button stays disabled until a new file is selected
        if (submitBtn) submitBtn.disabled = true;

      }).catch(function (xhr) {
        setSubmitLoading(false);
        const msg = (xhr && xhr.responseJSON && xhr.responseJSON.message)
          ? xhr.responseJSON.message
          : 'An error occurred. Please try again.';
        showMessage(msg, 'error');
        if (submitBtn) submitBtn.disabled = false;
      });
    });
  }

};
/* ── End theme.upload_document ─────────────────────────────────────────── */

theme.sf_checkout = function () {
  $('#sf-billing-form').submit(function (e) {
    e.preventDefault();
    let fields = ['firstName', 'lastName', 'email', 'billing_address1', 'billing_address2', 'billing_state', 'billing_city', 'billing_zip'];

    let form_data = '', custom_field_data = '';
    fields.forEach(function (field) {
      var value = $('#' + field).val();
      if (value !== '') {
        form_data += `&ai_${field}=${value}`;
      }
    });
    const custom_prefix = 'ai_custom_fields_';
    if (localStorage.getItem('locationData') != null) {
      let location_data = JSON.parse(localStorage.getItem('locationData'));
      custom_field_data += `${custom_prefix}scf_shop_7dc=${location_data.shop}`;
      custom_field_data += `&${custom_prefix}scf_country_du8=${location_data.country}`;
      custom_field_data += `&${custom_prefix}scf_city_86s=${location_data.city}`;
      custom_field_data += `&${custom_prefix}scf_building_name_ge6=${location_data.buildingName}`;
      custom_field_data += `&${custom_prefix}scf_floor_ef9=${location_data.floor}`;
      custom_field_data += `&${custom_prefix}scf_unit_gif=${location_data.unit}`;
      custom_field_data += `&${custom_prefix}scf_amid_fpe=${location_data.amid}`;
      custom_field_data += `&${custom_prefix}scf_suburb_4dr=${location_data.suburb}`;
      custom_field_data += `&${custom_prefix}scf_street_00j=${location_data.street1}`;
      custom_field_data += `&${custom_prefix}scf_region_xnp=${location_data.region}`;
      custom_field_data += `&${custom_prefix}scf_longitude_sym=${location_data.longitude}`;
      custom_field_data += `&${custom_prefix}scf_latitude_bw6=${location_data.latitude}`;
      if (location_data.conversionFlag && location_data.circuitNumber) {
        custom_field_data += `&${custom_prefix}scf__serviceid_3w7=${location_data.circuitNumber}`;
      }
    }
    if (form_data == '') {
      return false;
    }
    if (custom_field_data == '') {
      return false;
    }
    var urlString = window.location.href;
    function getParameters(urlString) {
      var urlParams = new URLSearchParams(urlString.split('?')[1]);  // Get query string parameters
      console.log('urlParams', urlParams);
      var vid = urlParams.get('v_Id');
      var pid = urlParams.get('p_Id');
      return {
        vid: vid,
        pid: pid
      };
    }
    var extractedParams = getParameters(urlString);
    var payLink = `https://connect.subscriptionflow.com/en/hosted-page/subscribe/${extractedParams.vid}/product/${extractedParams.pid}?${custom_field_data}`;
    console.log('payLink', payLink)

    window.location.href = payLink;

  });
}
// Removes any existing ai_firstName/ai_lastName/ai_email/ai_phone params from a
// URL before re-appending fresh ones — the base Subscribe-button link can already
// carry placeholder values (e.g. ai_firstName=Test), and without stripping first
// the real customer values get appended alongside them instead of replacing them.
function osStripAiCustomerParams(url) {
  try {
    let u = new URL(url);
    ['ai_firstName', 'ai_lastName', 'ai_email', 'ai_phone'].forEach(function (k) { u.searchParams.delete(k); });
    return u.toString();
  } catch (e) {
    return url;
  }
}
// Appends a raw `key=value&key2=value2` (or `&`-prefixed) string onto a URL,
// using '?' if the URL doesn't already have a query string and '&' if it does —
// stripping all params via osStripAiCustomerParams can leave a URL with no '?'
// at all, so blindly concatenating with '&' would produce an invalid URL.
function osAppendParams(url, paramsStr) {
  if (!paramsStr) return url;
  var clean = paramsStr.replace(/^[&?]/, '');
  if (!clean) return url;
  var sep = url.indexOf('?') === -1 ? '?' : '&';
  return url + sep + clean;
}
// Normalise any SA phone format (0821234567 / 27821234567 / +27821234567) to
// E.164 (+27821234567) — SF expects ai_phone in this format. encodeURIComponent
// then turns the leading "+" into "%2B".
function osNormalizePhoneE164(raw) {
  var c = String(raw || '').replace(/[^\d+]/g, '');
  if (!c) return '';
  if (c.charAt(0) === '+')      return c;
  if (c.charAt(0) === '0')      return '+27' + c.slice(1);
  if (c.slice(0, 2) === '27')   return '+' + c;
  return '+27' + c;
}
// GIS returns province names in ALL CAPS (e.g. "GAUTENG", "KWAZULU-NATAL"), but
// SubscriptionFlow's checkout state dropdown only accepts these exact 9 values —
// anything else fails to match an <option> and leaves the field unselected.
const SF_PROVINCE_MAP = {
  'EASTERN CAPE':   'Eastern Cape',
  'FREE STATE':     'Free State',
  'GAUTENG':        'Gauteng',
  'KWAZULU-NATAL':  'KwaZulu-Natal',
  'LIMPOPO':        'Limpopo',
  'MPUMALANGA':     'Mpumalanga',
  'NORTH WEST':     'North West',
  'NORTHERN CAPE':  'Northern Cape',
  'WESTERN CAPE':   'Western Cape',
};
function osNormalizeProvince(province) {
  if (!province) return '';
  return SF_PROVINCE_MAP[province.trim().toUpperCase()] || province;
}
theme.append_custom_data_subscription = function () {
  let custom_field_data = '';
  const custom_prefix = 'ai_custom_fields_';
  if (localStorage.getItem('locationData') != null) {
    let location_data = JSON.parse(localStorage.getItem('locationData'));
    custom_field_data += `${custom_prefix}scf_shop_7dc=${location_data.shop}`;
    custom_field_data += `&${custom_prefix}scf_country_du8=${location_data.country}`;
    custom_field_data += `&${custom_prefix}scf_city_86s=${location_data.city}`;
    custom_field_data += `&${custom_prefix}scf_building_name_ge6=${location_data.buildingName || ''}`;
    custom_field_data += `&${custom_prefix}scf_floor_ef9=${location_data.floor || ''}`;
    custom_field_data += `&${custom_prefix}scf_unit_gif=${location_data.unit || ''}`;
    custom_field_data += `&${custom_prefix}scf_amid_fpe=${location_data.amid}`;
    custom_field_data += `&${custom_prefix}scf_suburb_4dr=${location_data.suburb}`;
    custom_field_data += `&${custom_prefix}scf_street_00j=${location_data.street1}`;
    custom_field_data += `&${custom_prefix}scf_region_xnp=${location_data.region}`;
    custom_field_data += `&${custom_prefix}scf_longitude_sym=${location_data.longitude}`;
    custom_field_data += `&${custom_prefix}scf_latitude_bw6=${location_data.latitude}`;
    if (location_data.conversionFlag && location_data.circuitNumber) {
      custom_field_data += `&${custom_prefix}scf__serviceid_3w7=${location_data.circuitNumber}`;
    }
    // SF billing-address fields — country is always ZA; address1 is the full
    // formatted address (LR_Address/ADDRESS); address2/city reuse the same
    // region/city values sent above as scf_ fields; state comes from the GIS
    // LR_PROVINCE field (distinct from REGION); zip comes from LR_PO_CODE_STREET.
    custom_field_data += `&ai_billing_country=ZA`;
    custom_field_data += `&ai_billing_address1=${location_data.address1 || ''}`;
    custom_field_data += `&ai_billing_address2=${location_data.region || ''}`;
    custom_field_data += `&ai_billing_state=${osNormalizeProvince(location_data.province)}`;
    custom_field_data += `&ai_billing_city=${location_data.city || ''}`;
    custom_field_data += `&ai_billing_zip=${location_data.postalCode || ''}`;
  }

  // Set hrefs immediately with location/plan params (sync) so a click that
  // happens before the customer-profile fetch (below) resolves still carries
  // the coverage/plan data instead of a bare product link.
  document.querySelectorAll('.btn_subscribe_now').forEach(function (item) {
    let current_Url = osStripAiCustomerParams(item.querySelector('a').getAttribute('href'));
    let updated_Url = osAppendParams(current_Url, custom_field_data);
    item.querySelector('a').href = updated_Url;
  });

  // Customer-detail params (first name, last name, email, phone) — sourced from the
  // JWT/RICA session instead of Shopify's native customer session, since phone-only
  // OTP customers don't have one. Only available once RICA has been submitted.
  // Once resolved, top up the hrefs already set above with these extra params.
  // Also cached as a promise on `theme` — the click handler below awaits this
  // promise before showing the checkout popup, so a click that fires before this
  // network request finishes still ends up with the correct customer params
  // (the DOM href patch above is just a best-effort head start, not relied upon).
  theme.customerDetailParams = '';
  theme.customerDetailParamsPromise = Promise.resolve('');
  if (window.osCustomer && window.osCustomer.loggedIn) {
    theme.customerDetailParamsPromise = fetch('https://shopifyapp.openserve.co.za/api/customer/rica-profile', {
      headers: { 'Authorization': 'Bearer ' + OsSession.get() }
    }).then(function (r) { return r.json(); }).then(function (data) {
      var params = '';
      if (data && data.success) {
        if (data.first_name) params += `&ai_firstName=${encodeURIComponent(data.first_name)}`;
        if (data.last_name)  params += `&ai_lastName=${encodeURIComponent(data.last_name)}`;
        if (data.email)      params += `&ai_email=${encodeURIComponent(data.email)}`;
      }
      if (window.osCustomer.phone) params += `&ai_phone=${encodeURIComponent(osNormalizePhoneE164(window.osCustomer.phone))}`;
      theme.customerDetailParams = params;
      if (params) {
        document.querySelectorAll('.btn_subscribe_now').forEach(function (item) {
          var link = item.querySelector('a');
          link.href = osAppendParams(osStripAiCustomerParams(link.getAttribute('href')), params);
        });
      }
      return params;
    }).catch(function () { return ''; });
  }

  document.querySelectorAll('.btn_subscribe_now').forEach(function (item) {
    item.querySelector('a').addEventListener('click', function (e) {
      // Every branch below navigates manually (or shows a modal), and the RICA
      // decision may need to wait on the page-load status refresh — so always
      // prevent the default navigation up front (must be synchronous).
      e.preventDefault();
      var self = this;

      var storeCheckoutProduct = function () {
        try {
          sessionStorage.setItem('os_checkout_product', JSON.stringify({
            title: self.getAttribute('data-product-title') || '',
            price: self.getAttribute('data-product-price') || '',
            downSpeed: self.getAttribute('data-down-speed') || '',
            upSpeed: self.getAttribute('data-up-speed') || ''
          }));
        } catch (err) {}
      };

      // Wait for the fresh RICA status (window.osRicaStatusReady) before deciding,
      // so an already-submitted customer goes to checkout, not back to the form.
      var ready = window.osRicaStatusReady || Promise.resolve();
      ready.then(function () {
        // Guard: coverage must be checked first — shop field is required by backend
        var locationData = JSON.parse(localStorage.getItem('locationData') || '{}');
        if (!locationData.shop) {
          showEligibilityModal('Your coverage details are missing. Please check your coverage first before subscribing.', '/pages/coverage');
          return;
        }
        // Not logged in (custom WhatsApp login store) → go to login first, and
        // return to THIS product/collection page. After login, phone-login checks
        // the live RICA status: submitted → stays on PDP/PLP; not submitted → RICA
        // form. The login_button_click cookie carries the plan's checkout URL.
        if (window.osCustomer && !window.osCustomer.loggedIn) {
          storeCheckoutProduct();
          window.setCookie('login_button_click', self.getAttribute('href'), 7);
          var backTo = window.location.pathname + window.location.search;
          // subscribe=1 marks this as a Subscribe-initiated login so phone-login
          // routes by live RICA status afterward (PDP/PLP if done, else RICA form).
          window.location.href = '/pages/login?subscribe=1&return_to=' + encodeURIComponent(backTo);
          return;
        }
        // window.ricaSubmitted (old Shopify metafield) is no longer set for OTP;
        // osCustomer.ricaSubmitted was refreshed from the DB on page load.
        var ricaSubmitted = window.ricaSubmitted || (window.osCustomer && window.osCustomer.ricaSubmitted);
        if (!ricaSubmitted) {
          storeCheckoutProduct();
          // Store the SF checkout URL for THIS plan so that after RICA submission
          // the customer lands directly on SF checkout. Overwrite avoids a stale
          // cookie from an earlier Subscribe click on a different plan winning.
          window.setCookie('login_button_click', self.getAttribute('href'), 7);
          window.location.href = '/pages/document-submit';
        } else {
          // Already RICA'd — show the pre-checkout confirmation popup.
          storeCheckoutProduct();
          var baseHref = self.getAttribute('href');
          (theme.customerDetailParamsPromise || Promise.resolve(theme.customerDetailParams || '')).then(function (params) {
            var finalHref = osAppendParams(osStripAiCustomerParams(baseHref), params || theme.customerDetailParams || '');
            if (typeof window.osShowCheckoutPopup === 'function') {
              window.osShowCheckoutPopup(finalHref);
            } else {
              window.location.href = finalHref;
            }
          });
        }
      });
    });
  });
}
document.addEventListener("DOMContentLoaded", (event) => {
  theme.coveragePageLoader();
  theme.getUrlFilterMap();
  // theme.match_media_plan();
  theme.tab_content();
  theme.custom_banner_slider();
  // theme.custom_megamenu_click();

  $(".Server_number input").on("keyup change", function (e) {
    if (this.value.length > 0) {
      // $(this).closest(".product-form").find(".product-form__buttons .product-form__submit").attr('disabled', false);
      $(this).closest(".product-form").find(".server_number_error").text("");
      $(this).closest(".product-form").find(".verify-service-number").removeAttr("disabled").addClass("align-self-end").removeClass("align-self-center");
      $(this).closest(".product-form").find(".verify-service-number span").text("Verify");
    }
    else {
      // $(this).closest(".product-form").find(".product-form__buttons .product-form__submit").attr('disabled', true);
      $(this).closest(".product-form").find(".server_number_error").text("Please enter service number");
      $(this).closest(".product-form").find(".verify-service-number").attr("disabled", "disabled").removeClass("align-self-end").addClass("align-self-center");
    }
    // console.log(this.value.length);
  })

  if ($('.speed-guide-information-section').length > 0) {
    const option_1 = document.getElementById("title_mbps");
    const option_2 = document.getElementById("mbps");
    const info_data = document.getElementById("data");
    const bottom_content = document.getElementById("bottom-content");
    const targeted_content = document.getElementById("targeted-customer");
    theme.mbps.map(data => {
      var options = data.option;
      option_1.innerHTML += `<option value="${options}">${options}</option>`;
      var selected_val = document.getElementById("title_mbps").value;
      if (selected_val == options) {
        var option_mbps = data.option1;
        option2_append(option_mbps);
      }
      var selected_val2 = option_2.value;
      data.mbps_data.map(mbpsd => {
        option2_datachange(mbpsd, selected_val2, selected_val, options);
      });
      bottom_content.innerHTML = `${data.bottom_content}`
    });
    option_1.addEventListener("change", (event) => {
      theme.mbps.map(data => {
        var options = data.option;
        var selected_val = document.getElementById("title_mbps").value;
        if (selected_val == options) {
          option_2.innerHTML = '';
          var option_mbps = data.option1;
          option2_append(option_mbps);
          bottom_content.innerHTML = `${data.bottom_content}`
          data.mbps_data.map(mbpsd => {
            var selected_val2 = option_2.value;
            option2_datachange(mbpsd, selected_val2, selected_val, options);
          });
        }
      });
    });
    option_2.addEventListener("change", (event) => {
      theme.mbps.map(data => {
        var options = data.option;
        data.mbps_data.map(mbpsd => {
          var selected_val = option_1.value;
          var selected_val2 = option_2.value;
          option2_datachange(mbpsd, selected_val2, selected_val, options);
        });
      });
    });
    function option2_append(option_mbps) {
      var single_mbps = option_mbps.split(',');
      single_mbps.forEach(function (value, index) {
        option_2.innerHTML += `<option value="${value}">${value} <span>mbps</span></option>`;
      })
    }
    function option2_datachange(mbpsd, selected_val2, selected_val, options) {
      var data_id = mbpsd.id;
      if (selected_val == options && selected_val2 == data_id) {
        var info1 = mbpsd.info1, info2 = mbpsd.info2, info3 = mbpsd.info3, info4 = mbpsd.info4;
        if (info1.includes('|')) {
          info1 = info1.split('|');
          var info1_data = `<div>Suggested users:${info1[0]}</div><div>Connected devices:${info1[1]}</div>`;
        } else {
          var info1_data = `<div>Suggested users:${info1}</div>`;
        }
        if (info2.includes('|')) {
          info2 = info2.split('|');
          var info2_data = `<div>Concurrent HD users:${info2[0]}</div><div>Concurrent 4K users:${info2[1]}</div>`;
        } else {
          var info2_data = `<div>Suggested users:${info2}</div>`;
        }
        if (info3.includes('|')) {
          info3 = info3.split('|');
          var info3_data = `<div>Download 1 GB in:${info3[0]}</div><div>Conference call quality:${info3[1]}</div>`;
        } else {
          var info3_data = `<div>Suggested users:${info3}</div>`;
        }
        if (info4.includes('|')) {
          info4 = info4.split('|');
          var info4_data = `<div>Download 50 GB in:${info4[0]}</div><div>Local gaming ping:${info4[1]}</div>`;
        } else {
          var info4_data = `<div>Suggested users:${info4}</div>`;
        }
        info_data.innerHTML = `<div class="main-info-wrap">
                  <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head1}</div>
                  <img src="${mbpsd.img1}" height="100px" width="100px">
                  <div class="info-data">${info1_data}</div>
                  </div>
                </div>
                <div class="main-info-wrap">
                <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head2}</div>
                  <img src="${mbpsd.img2}" height="100px" width="100px">
                  <div class="info-data">${info2_data}</div>
                  </div>
                </div>
                <div class="main-info-wrap">
                <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head3}</div>
                  <img src="${mbpsd.img3}" height="100px" width="100px">
                  <div class="info-data">${info3_data}</div>
                  </div>
                </div>
                <div class="main-info-wrap">
                <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head4}</div>
                  <img src="${mbpsd.img4}" height="100px" width="100px">
                  <div class="info-data">${info4_data}</div>
                </div>
                </div>`
        targeted_content.innerHTML = `<span class="content-head">Suite to:</span><span class="content">${mbpsd.targeted_customer}</span>`;
      }
    }
  }
  // check wheather iframe loaded or not
  if ($('.coverage-main').length > 0) {
    const iframe = document.getElementById("map-iframe");
    $(iframe).on('load', function () {
      //your code (will be called once iframe is done loading)
      //  console.log("loadeddd");
      $('.loader-data').remove();
      $(iframe).css('display', 'block');
    });
  }
  $('.mega-menu #HeaderMenu-fibre-package').on('mouseover', function () {
    // $('#MegaMenu-Content-2').html("helloo");
    var url = `/`;
    $.ajax({
      url: url,
      success: function (data) {
        const html = new DOMParser().parseFromString(data, "text/html");
        var event_list = html.querySelector('.shopify-section-group-header-group.plans-tab .tab-content-main-wrapper');
        document.getElementById('MegaMenu-Content-fiber-package').innerHTML = event_list.outerHTML;
        setTimeout(() => {
          theme.tab_content();
        }, 500);
      }
    });
  });
  //dynamic announcementbar height
  var announcement_height = $('.announcement-bar-section').height();
  $('.search-modal.modal__content.gradient').css('top', announcement_height);
  if (document.body.classList.contains('template-product')) {
    var speed_option = document.getElementById("mbps"),
      place_option = document.getElementById("title_mbps");

    if (place_option) {
      let place_type = document.querySelector('.dynamic-data').getAttribute('data-placeType');
      var capitalizedString = place_type.toLowerCase().replace(/\b\w/g, function (word) { return word.toUpperCase(); });
      place_option.value = capitalizedString;
      const place_event = new Event('change');
      place_option.dispatchEvent(place_event);
    }

    if (speed_option) {
      let download_speed = document.querySelector('.dynamic-data').getAttribute('data-downloadSpeed').split(' ')[0];
      speed_option.value = download_speed;
      const speed_event = new Event('change');
      speed_option.dispatchEvent(speed_event);
    }

    $('.verify-service-number').on('click', (e) => {
      const API_URL = "https://openserve.novux.co.za";
      $(e.target).parents(".Server_number").find(".prepaid_server_number").attr("disabled", "disabled");
      $(e.target).parents(".Server_number").find(".verify-service-number").attr("disabled", "disabled");
      $(e.target).parents(".Server_number").find(".verify-service-number i").removeClass("hidden");
      $(e.target).parents(".Server_number").find(".verify-service-number span").addClass("hidden");
      e.preventDefault();
      console.log('verify service number');
      const serviceNumber = $('.prepaid_server_number').val();
      console.log(serviceNumber);
      if (!serviceNumber) return;
      const formData = new FormData();
      formData.append('serviceId', serviceNumber);
      fetch(API_URL + '/api/getprepaidservice', {
        method: 'POST',
        body: formData
      })
        .then(res => res.json())
        .then(data => {
          $(e.target).parents(".Server_number").find(".verify-service-number i").addClass("hidden");
          $(e.target).parents(".Server_number").find(".verify-service-number span").removeClass("hidden");
          $(e.target).parents(".Server_number").find(".prepaid_server_number").removeAttr("disabled");
          if (data.success) {
            $(e.target).parents(".Server_number").find(".verify-service-number span").text("Verified!").removeClass("hidden");
            $(".product-form .product-form__buttons .product-form__submit").attr('disabled', false);
            $(".product-form .server_number_error").text("");
          }
          else {
            $(e.target).closest(".product-form").find(".verify-service-number").attr("disabled", "disabled").removeClass("align-self-end").addClass("align-self-center");
            $(".product-form .product-form__buttons .product-form__submit").attr('disabled', true);
            $(".product-form .server_number_error").text(data.error);
          }
        })
        .catch(error => {
          $(e.target).parents(".Server_number").find(".prepaid_server_number").removeAttr("disabled");
          $(e.target).parents(".Server_number").find(".verify-service-number").removeAttr("disabled");
          $(e.target).parents(".Server_number").find(".verify-service-number i").addClass("hidden");
          $(e.target).parents(".Server_number").find(".verify-service-number span").removeClass("hidden");
          console.error(error);
        });
    });

  }
  // click event when click on order now event
  if (document.body.classList.contains('page--coverage')) {
    // Bind the delegated Order-Now handler immediately, not from the poller
    // below. This makes it active from page load so a fast click during the
    // first search can never bypass the coverage check.
    theme.coverage_orderNow_click();

    let has_class = setInterval(() => {
      if (document.querySelector('.has_product_available')) {
        console.log("class find");
        var parentDiv = document.querySelector('#newAddressBtn .divAlignCenter');
        console.log('parentDiv', parentDiv);
        // Check if the parent element exists
        if (parentDiv) {
          // Add the 'disabled' class to the parent element
          parentDiv.classList.remove('enabled');
          parentDiv.classList.add('disabled');
          console.log('parentDivif', parentDiv);
          // Optionally, you can disable any child elements if needed
          var link = parentDiv.querySelector('#confirmAdr');
          console.log('link', link);
          if (link) {
            link.style.pointerEvents = 'none'; // Prevent interaction
            link.style.cursor = 'not-allowed';  // Change cursor
          }
        }

        clearInterval(has_class);
      }
    }, 1000);
  }
  if (document.body.classList.contains('template-product')) {
    console.warn('pdp pageee')
    if (localStorage.getItem('locationData') != null) {
      let location_data = JSON.parse(localStorage.getItem('locationData'));
      // formData.append(`[properties][_shop]`, 'shopname');
      const product_form = document.querySelector('.shopify-payment-button')?.closest('form');
      let location_input = `<input type="hidden" name="properties[_shop]" value="${location_data.shop}">
      <input type="hidden" name="properties[_country]" value="${location_data.country}">
      <input type="hidden" name="properties[_city]" value="${location_data.city}">
      <input type="hidden" name="properties[_buildingName]" value="${location_data.buildingName}">
      <input type="hidden" name="properties[_floor]" value="${location_data.floor}">
      <input type="hidden" name="properties[_unit]" value="${location_data.unit}">
      <input type="hidden" name="properties[_amid]" value="${location_data.amid}">
      <input type="hidden" name="properties[_suburb]" value="${location_data.suburb}">
      <input type="hidden" name="properties[_street1]" value="${location_data.street1}">
      <input type="hidden" name="properties[_region]" value="${location_data.region}">
      <input type="hidden" name="properties[_longitude]" value="${location_data.longitude}">
      <input type="hidden" name="properties[_latitude]" value="${location_data.latitude}">`
      if (product_form != undefined) {
        product_form.insertAdjacentHTML('beforeend', location_input);
      }
    }
  }
  //create ticket button click 
  document.querySelector('.creat-ticket-btn')?.addEventListener("click", function () {
    if (window.isCustomer === 'true') {
      document.getElementById('create_form').classList.add('has_popup_open');
      document.body.classList.add('body_overlay');
      theme.ticket_form_submit_api();
    } else {
      const parentElement = document.querySelector('.creat-ticket-button-wrapper');
      if (document.getElementById('customer-error') == null) {
        const newElement = document.createElement('div');
        newElement.textContent = 'please login to the account to create ticket'; // Optionally, set some content
        newElement.setAttribute('id', 'customer-error');
        // Get the first child of the parent element
        const firstChild = parentElement.firstChild;
        // Insert the new element before the first child
        parentElement.insertBefore(newElement, firstChild);
      }
    }
  })
  // if customer login then display ticket data append
  let data_suffix = document.body.getAttribute('data-suffix');
  if (window.isCustomer === 'true' && data_suffix === 'ticket-form') {
    console.log('isCustomer', window.isCustomer);
    theme.ticket_data_list_api();
  }
  // ticket form close on click
  document.querySelector('.close-form-popup')?.addEventListener('click', function () {
    document.getElementById('create_form').classList.remove('has_popup_open');
    document.body.classList.remove('body_overlay');
  });
  //Rica documents submit api call
  if (data_suffix == 'document-submit') {
    theme.rica_document_submit();

    // Dynamic ID number hint based on selected ID type
    const idTypeSelect = document.getElementById('id_type');
    const idHint = document.getElementById('id-number-hint');
    const idInput = document.getElementById('id_number');
    const idHints = {
      'sa_id': 'Must be exactly 13 digits. Example: 9001015009087',
      'sa_passport': 'South African passport number as shown on your passport.',
      'foreign_passport': 'Passport number as shown on your foreign passport.',
      '': 'Select an ID type above to see the required format.'
    };
    if (idTypeSelect && idHint) {
      idTypeSelect.addEventListener('change', function () {
        idHint.innerText = idHints[this.value] || idHints[''];
        if (idInput) idInput.placeholder = this.value === 'sa_id'
          ? 'e.g. 9001015009087'
          : 'Enter your passport number';
      });
    }
  }
  if (window.isCustomer == true && (window.customer_hasSubmitted == false || window.customer_hasSubmitted == '')) {
    if (!window.location.pathname.includes('document-submit')) {
      theme.rica_after_submit();
    }
  }
  // ID Document upload page
  if (data_suffix == 'upload-document') {
    theme.upload_document();
  }
  /* Subscription flow custom field pass start */
  // if(data_suffix == 'sf-checkout'){
  //   theme.sf_checkout();
  // }
  // if(document.body.classList.contains('template-product')){
  theme.append_custom_data_subscription();
  // }
  /* Subscription flow custom field pass end */
  /* Custom thank page loader stop start */
  if (data_suffix == 'custom-thank-you') {
    setTimeout(() => {
      document.getElementById('custom-thank-you-loader').style.display = 'none';
      document.querySelector('.custom-thankyou-inner-main').style.display = 'block';
    }, 2000);
  }
  /* Custom thank page loader stop end */
});


/* footer image height set variable start */
function setImageHeightVar() {
  const img = document.querySelector('.footer .top-image img');

  if (img) {
    const height = img.clientHeight / 2;
    document.querySelector('html').style.setProperty('--footer-img-height', height + 'px');
  }
}

window.addEventListener('load', setImageHeightVar);
window.addEventListener('resize', setImageHeightVar);
/* footer image height set variable end */